// Budget range display formatting.
//
// A budget is optional: the backend stores and returns null when the
// homeowner leaves it blank. A missing budget must be distinguished from a
// real zero -- pg returns numeric(10,2) as the STRING "0.00", so a
// truthiness check would swallow a genuine $0.00 floor (requests 66 and 83
// carry one). isMissing() below is the only place that test lives.

export type BudgetValue = string | number | null | undefined;

// Surfaces with no "Budget:" label of their own carry the word themselves.
export const BUDGET_NOT_SPECIFIED = 'Budget not specified';
// Surfaces already labelled "Budget:" would otherwise read "Budget: Budget not specified".
export const BUDGET_NOT_SPECIFIED_BARE = 'Not specified';

function isMissing(value: BudgetValue): boolean {
  return value === null || value === undefined || value === '';
}

function formatBudget(min: BudgetValue, max: BudgetValue, missingText: string): string {
  if (isMissing(min) || isMissing(max)) return missingText;
  return '$' + min + ' - $' + max;
}

// For unlabelled surfaces (browse cards, my-requests rows).
export function formatBudgetRange(min: BudgetValue, max: BudgetValue): string {
  return formatBudget(min, max, BUDGET_NOT_SPECIFIED);
}

// For surfaces that already print a "Budget:" label.
export function formatBudgetValue(min: BudgetValue, max: BudgetValue): string {
  return formatBudget(min, max, BUDGET_NOT_SPECIFIED_BARE);
}
